{
  "not_found": "Не удалось загрузить шаблон найма",
  "add_employee": "Добавить сотрудника",
  "title": "Шаблоны найма",
  "new_template": "Новый шаблон найма",
  "copy_from": "Скопировать настройки из (необязательно)",
  "select_template": "Выберите шаблон",
  "copy_hint": "Настройки будут скопированы в новый шаблон. Их можно изменить позже.",
  "last_updated": "Последнее изменение",
  "archive_confirm": "Архивировать шаблон «{title}»?",
  "main": "Основное",
  "personal": "Личные данные",
  "onboarding": "Настройка онбординга",
  "add_section": "Добавить секцию",
  "rename_section": "Переименовать",
  "system_section_title_reset_hint": "Название по умолчанию: {title}",
  "delete_section": "Удалить секцию",
  "make_optional": "Сделать необязательным",
  "make_mandatory": "Сделать обязательным",
  "hide_field": "Скрыть из формы",
  "show_field": "Показать в форме",
  "optional": "Необязательно",
  "disabled": "Отключено",
  "can_change": "Можно изменить",
  "cannot_change": "Нельзя изменить",
  "compensation_after_probation": "Компенсация после испытательного срока",
  "will_be_launched_and": "будут запущены и",
  "saved": "Шаблон сохранён",
  "section_position": "Рабочие данные",
  "section_employment": "Занятость",
  "section_compensation": "Компенсация",
  "section_employee_basic_info_manager": "Руководитель",
  "section_employee_basic_info_personal": "Личные данные",
  "section_employee_basic_info_contacts": "Контакты",
  "section_employee_basic_info_address": "Адрес",
  "section_employee_basic_info_hired_via_job": "Данные найма",
  "section_custom": "Секция",
  "preview_form": "Предпросмотр формы",
  "preview_hint": "Режим предпросмотра: сотрудник не будет создан, изменения не сохранятся.",
  "preview_complete": "Предпросмотр завершён",
  "hire_queued": "Найм выполняется",
  "hire_queued_hint": "Обычно это занимает несколько секунд. Профиль сотрудника откроется автоматически.",
  "hire_failed": "Не удалось отправить форму найма. Попробуйте ещё раз.",
  "new_employee_from_this": "Новый сотрудник по этому шаблону",
  "probation_date_invalid": "Дата окончания испытательного срока не может быть раньше даты начала работы.",
  "compensation_after_probation_title": "Компенсация после испытательного срока",
  "hire_job_failed": "Не удалось нанять сотрудника. Попробуйте ещё раз.",
  "hire_status_unknown": "Не удалось узнать статус найма",
  "hire_status_unknown_hint": "Найм может ещё выполняться. Проверьте список сотрудников через несколько минут, прежде чем пробовать снова.",
  "go_to_employees": "Перейти к сотрудникам"
}
